import { Component, Input, OnInit } from '@angular/core';

import { Product } from '../../../../../canvas/components/business-areas/products/product';
import { ProductsService } from '../../../../../canvas/components/business-areas/products/products.service';

@Component({
  selector: 'app-service-society',
  templateUrl: './service-society.component.html',
  styleUrls: ['./service-society.component.css']
})
export class ServiceSocietyComponent implements OnInit {

  @Input() onShowPeriod;
  windowWith;
  products: Product [];
  mockProducts: Product [] = [];

  constructor(
    private _productsService: ProductsService) {}

  getProducts(): void {
    this._productsService.getProducts().then(products => this.products = products);
  }

  getMockProducts(): void {
    this._productsService.getMockProducts().then(mockProducts => this.mockProducts = mockProducts);
  }

  ngOnInit() {
    this.windowWith = window.innerWidth;
    this.getMockProducts();
    this.getProducts();
  }

  onResize(event) {
    this.windowWith = event.target.innerWidth;
  }

  breakRow(theArr: any[]) {
    const arrOfarr = [];
    if (this.windowWith > 768) {
      for (let i = 0; i < theArr.length ; i+=3) {
        const row = [];
        for (let x = 0; x < 3; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } if (this.windowWith > 480) {
      for (let i = 0; i < theArr.length ; i+=2) {
        console.log(this.windowWith);
        const row = [];
        for (let x = 0; x < 2; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    } else {
      for (let i = 0; i < theArr.length ; i+=1) {
        const row = [];
        for (let x = 0; x < 1; x++) {
          const value = theArr[i + x];
          if (!value) {
            break;
          }
          row.push(value);
        }
        arrOfarr.push(row);
      }
      return arrOfarr;
    }
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/keynote/components/today/components/service-society/service-society.component.ts